import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import {
  getShopifyProducts,
  getWooProducts,
  syncedProducts,
  syncedProduct,
  getThisProduct,
} from 'actions/products';
import SubHeader from 'components/SubHeader';
import { ROUTES } from 'shared/constants/routes';
import ProductDetail from 'pages/sync-product/ProductDetail';
import ProductInformation from 'pages/sync-product/ProductInformation';
import {
  Container,
  NoProductFound,
  CardTitle,
} from 'styles/pages/sync-product';

const SyncProduct = () => {
  const dispatch = useDispatch();
  const email = useSelector((state) => state?.auth?.profile?.emailid);
  const [product, setProduct] = useState(undefined);
  const { productId, marketPlaceType, shopName } = useParams();

  useEffect(() => {
    const getData = async () => {
      // let products =
      //   marketPlaceType === 'Shopify'
      //     ? await dispatch(
      //         getShopifyProducts({
      //           user: email,
      //           shopName,
      //         })
      //       )
      //     : await dispatch(
      //         getWooProducts({
      //           user: email,
      //           shopName,
      //         })
      //       );

      // products = products?.products || products;

      // const selectedProduct = products?.find(
      //   (p) => p?.id === Number(productId)
      // );

      const syncedP = await dispatch(
        syncedProducts({
          shopName,
          emailid: email,
        })
      );

      const synced = !!syncedP?.find((s) => Number(productId) === s?.id);

      if (synced) {
        const p = await dispatch(
          syncedProduct({
            emailId: email,
            productId: Number(productId),
          })
        );

        setProduct(() => ({
          ...p[0],
          synced,
          variants: p[0]?.variants || p[0]?.variations,
        }));
      } else {
        const p = await dispatch(
          getThisProduct({
            marketPlace: marketPlaceType,
            user: email,
            shopName,
            id: productId,
          })
        );

        setProduct(() => ({
          ...p,
          synced,
          variants: p?.variants || p?.variations,
        }));
      }
    };
    if (!product) {
      getData();
    }
  }, [marketPlaceType, productId, product, productId, shopName]);

  if (!product || !product?.variants?.length) {
    return <NoProductFound>No Product Found!</NoProductFound>;
  }

  return (
    <Container>
      <SubHeader
        title={ROUTES.MY_STORES_SYNC_PRODUCT.TITLE}
        links={[
          {
            title: ROUTES.MY_STORES_SYNC_PRODUCTS.TITLE,
            to: ROUTES.MY_STORES_SYNC_PRODUCTS.LINK,
          },
        ]}
        currentPageTitle={ROUTES.MY_STORES_SYNC_PRODUCT.TITLE}
      />
      <ProductInformation
        marketPlaceType={marketPlaceType}
        product={product}
        setProduct={setProduct}
      />

      <CardTitle>Variants</CardTitle>
      <ProductDetail
        product={product}
        setProduct={setProduct}
        marketPlaceType={marketPlaceType}
        shopName={shopName}
      />
    </Container>
  );
};

export default SyncProduct;
